import { DotIcon } from 'components/Icons'
import React from 'react'
import { useTranslation } from 'react-i18next';
import useToggle from 'utils/customHooks/useToggle';
import ButtonComponent from './ButtonComponent'

const SubscribeComponent = ({ showDot = true }) => {
    const { t } = useTranslation();
    const [subscribed, setSubscribed] = useToggle();

    const subscribeClick = () => {
        setSubscribed();
    }

    return (
        <div className={'h-100 d-flex justify-content-center align-items-center subscribe-btn-container'}>
            {
                showDot ?
                    <span className={'mx-1 text-light-gray h-100'}><DotIcon /></span> :
                    null
            }
            <ButtonComponent
                type={'button'}
                onClick={subscribeClick}
                btnText={subscribed ? t('subscribe') : t('subscribed')}
                transparent={true}
                customClass={'subscribe-btn capitalize btn-transparent h-100'}
                isBold={false}
                textClassName={'h-100 font-size-12 text-light font-weight-normal'}
            />
        </div>
    )
}

export default SubscribeComponent;
